export const logger = (type: 'log' | 'error' | 'warn' = 'log', ...args: any) => {
    if(!(window as any).salla?.logger){
        return console[type]('%cSalla-Accounts', 'font-weight:bold; border:1px solid #bbf3e5; padding: 2px 6px; border-radius: 5px; color:#bbf3e5', ...args);
    }
    return (window as any).salla?.logger[type](...args);
}
export const log = (...args: any) => {
    return logger('log', ...args);
};

export const error = (...args: any) => {
    return logger('error', ...args);
};

export const warn = (...args: any) => {
    return logger('warn', ...args);
};

export const parentMessage = (message: any, type: 'ready' | 'height' | 'authenticated_web_auth' | 'authenticated' | 'notify' | 'dispatchEvent' | 'storage' | 'reload' | 'logged-out' | string) => {
    if(!inIframe()){
        return Salla.event.emit(`login::${type}`, message);
    }
    type = `iframe::${type}`;
    log('parent.postMessage', type, message);
    return window.parent.postMessage({
        source: "login",
        message: message,
        type: type
    }, "*");
}

export function inIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}


export async function waitForCondition(
  callback: () => boolean,
  timeout = 10000,
  interval = 50
) {
  const start = Date.now();

  while (Date.now() - start < timeout) {
    if (callback()) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, interval));
  }

  return false;
}

export async function waitForTurnstile(widgetId: string = "#cloudflare-turnstile-widget") {
    // if(!salla.config.get('store.features', []).includes('re-captcha-v3')){
    //     return true;
    // }
    //to make sure that the header is removed, to avoid doublicated key
    salla.api.setHeader( 's-render-key', null );
    let isPassed = await waitForCondition(() => !!window.turnstile);

    window.turnstile.remove(widgetId);
    isPassed = isPassed && !!window.turnstile.render(widgetId);

    isPassed = isPassed && await waitForCondition(() => !!salla.api.getHeader('s-render-key'), 20000);
    if (!isPassed) {
       Salla.analytics.log("Login Error::waitForTurnstile timeout", { error_type: "re-captcha-v3::timeout" });
    }
    return isPassed;
  }

export function getTheme(): string {
  return document.documentElement.classList.contains("dark") ? 'dark' : 'light';
}

export const toggleDarkMode = (isDark: boolean) =>
  isDark
    ? document.documentElement.classList.add('dark')
    : document.documentElement.classList.remove('dark');
